import HttpClient from "./httpClient";

export const WORKFLOW_TYPES = ["User Onboarding", "User Offboarding"] as const;
export type WorkflowType = (typeof WORKFLOW_TYPES)[number];

export interface CustomWorkflow {
  id: number;
  msp_id: number;
  customer_id: number | null;
  workflow_name: string;
  workflow_type?: WorkflowType;
  steps_json: { steps: unknown[]; auto_continue_hitl?: boolean };
  created_by?: string;
  last_updated_by?: string;
  created_at: string;
  updated_at: string;
}

class CustomWorkflowApi extends HttpClient {
  public getWorkflows = (customerId?: string) =>
    this.get(
      "/custom-workflows",
      {},
      customerId && customerId !== "all" ? { customerId } : {}
    );

  /** Upload a skeleton PDF template for a workflow step (e.g. welcome letter). */
  public uploadPdfTemplate = (payload: { filename: string; content_base64: string }) =>
    this.post("/custom-workflows/pdf-template", {}, payload) as Promise<{
      object_name: string;
      filename: string;
    }>;

  public getWorkflowById = (id: string | number) =>
    this.get(`/custom-workflows/${id}`, {});

  public createWorkflow = (workflow: {
    msp_id?: number;
    customer_id: number;
    workflow_name: string;
    workflow_type?: WorkflowType;
    steps_json?: { steps: unknown[] };
    created_by?: string;
    last_updated_by?: string;
  }) => this.post("/custom-workflows", {}, workflow);

  public updateWorkflow = (workflow: {
    id: number;
    customer_id: number;
    workflow_name: string;
    workflow_type?: WorkflowType;
    steps_json?: { steps: unknown[] };
    last_updated_by?: string;
  }) => this.put(`/custom-workflows/${workflow.id}`, {}, workflow);

  public deleteWorkflow = (id: string | number) =>
    this.del(`/custom-workflows/${id}`, {});
}

export default CustomWorkflowApi;
